// extracted by mini-css-extract-plugin
module.exports = {"image":"svg-icon-view_image__YgNNk","image__loaded":"svg-icon-view_image__loaded__1IZFt","image__cached":"svg-icon-view_image__cached__2Rdmc"};